import React from 'react';
import styles from './checkbox.module.scss';

const ToggleSwitch = ({visible: isOn, update, id}) => {

    const toggle = (e) => {
        e.stopPropagation()
        update({visible: !isOn, id});
    }

    return (
        <div className={styles.switch} onClick={(e)=>toggle(e)} >
            <div className={`${styles.slider} ${isOn ? styles.on : ''}`}>
                <div className={styles.circle}></div>
            </div>
        </div>
    );
};

export default ToggleSwitch;